<template>
  <a-form
    class="mod-order-form"
    layout="horizontal"
    labelAlign="left"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    :colon="false"
    :form="form"
    @submit="onSubmit"
  >
    <a-form-item :wrapper-col="wrapperColOffset">
      <div style="text-align: center">请输入任意一次一年内出行的订单信息</div>
    </a-form-item>
    <a-form-item label="乘机人">
      <a-input
        size="large"
        placeholder="请输入行程中的一位乘机人姓名"
        v-decorator="[
          'fullName',
          {
            rules: [
              {
                validator: handleFieldValidate
              }
            ],
            validateTrigger: 'blur'
          }
        ]"
      >
      </a-input>
    </a-form-item>
    <a-form-item label="出发城市">
      <air-flight-city-selector
        :data-source="cities"
        size="large"
        placeholder="出发城市"
         v-decorator="[
          'departure',
          {
            rules: [
              {
                validator: handleFieldValidate
              }
            ]
          }
        ]"
      >
        <a-icon slot="suffix" type="environment" />
      </air-flight-city-selector>
    </a-form-item>
    <a-form-item label="到达城市">
      <air-flight-city-selector
        :data-source="cities"
        size="large"
        placeholder="到达城市"
         v-decorator="[
          'arrival',
          {
            rules: [
              {
                validator: handleFieldValidate
              }
            ]
          }
        ]"
      >
        <a-icon slot="suffix" type="environment" />
      </air-flight-city-selector>
    </a-form-item>
    <a-form-item :wrapper-col="wrapperColOffset">
      <a-button style="margin: 0; width: 100%" type="primary" size="large" :loading="loading" html-type="submit">提交校验</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import { validate } from '@/utils/validate'
// import cities from '@/data/city'
import { securityVerify } from '@/api/member'
import { flightcities } from '@/api/data'

export default {
  data () {
    return {
      labelCol: {
        span: 4
      },
      wrapperCol: {
        span: 20
      },
      wrapperColOffset: {
        span: 20, offset: 4
      },
      form: this.$form.createForm(this),
      cities: [],
      loading: false
    }
  },
  created () {
    this.fetchCities()
  },
  methods: {
    handleFieldValidate (rule, value, callback) {
      validate('security-order', this.form.getFieldsValue(), rule.fullField).then(({ valid, error }) => {
        if (valid) {
          callback()
        } else {
          callback(error)
        }
      })
    },
    onSubmit (e) {
      e.preventDefault()

      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          this.loading = true

          try {
            const data = await securityVerify({
              check: {
                type: 2,
                passenger: values.fullName,
                dep: values.departure,
                arr: values.arrival
              }
            })

            this.$success({
              content: '登录成功',
              centered: true,
              onOk: () => {
                if (!data.fullName) {
                  data.fullName = '手机用户'
                }

                this.$ls.set('USER_CENTER_INFO', data)
                window.__MICRO_ROOT__ && window.__MICRO_ROOT__.eventBus.emit('user.login.success', null, {
                  ...data,
                  token: this.$ls.get('USER_CENTER_TOKEN')
                })
              }
            })
          } catch (err) {
            this.$error({
              content: err.message,
              centered: true
            })
            this.loading = false
          }
        }
      })
    },
    async fetchCities () {
      try {
        this.cities = await flightcities()
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>
